import RightArrow from '@public/icons/arrow-small-right.svg';
import Checkmark from '@public/icons/checkmark-black.svg';
import clsx from 'clsx';
import Image from 'next/image';
import React, { useState } from 'react';

import type { CardT } from '@/utils/contentfulTypes';

import { ContentfulTextContainer } from '../ContentfulTextContainer';
import FiveStars from '../FiveStars';

interface TestimoniesProps {
  data: CardT[];
}

const Testimonies: React.FC<TestimoniesProps> = ({ data }) => {
  const [currTestimony, setCurrTestimony] = useState<CardT>(data[0]);
  const nextTestimony = () => {
    const nextIndex = data.indexOf(currTestimony) + 1;
    if (nextIndex < data.length) {
      setCurrTestimony(data[nextIndex]);
    } else {
      setCurrTestimony(data[0]);
    }
  };
  const prevTestimony = () => {
    const prevIndex = data.indexOf(currTestimony) - 1;
    if (prevIndex >= 0) {
      setCurrTestimony(data[prevIndex]);
    } else {
      setCurrTestimony(data[data.length - 1]);
    }
  };
  return (
    <section className="py-11 px-4 bg-white font-light md:px-20">
      <div className="width-1440 mt-20">
        <div className="grid gap-10 items-center md:grid-cols-2 lg:gap-20">
          <div className="relative w-full aspect-square">
            {data.map((testimony) => (
              <Image
                key={testimony.subheadline}
                src={testimony.image.url}
                alt={testimony.subheadline}
                height={700}
                width={700}
                className={clsx(
                  'absolute object-cover mx-auto rounded-2xl',
                  testimony === currTestimony ? 'opacity-100' : 'opacity-0'
                )}
              />
            ))}
          </div>
          <div>
            <FiveStars />
            <ContentfulTextContainer
              markdown={currTestimony.text}
              className="mt-8 text-alter-black [&_p]:leading-snug [&_p]:text-2xl lg:[&_p]:text-[32px]"
            />
            <div className="flex items-center gap-3 md:mt-2">
              {/* <Image
                src={currTestimony.imageMobile.url}
                alt={currTestimony.subheadline}
                height={48}
                width={48}
                className="object-contain aspect-square"
              /> */}
              <div className="">
                <div>{currTestimony.subheadline}</div>
                <div className="flex gap-1 text-alter-black-60">
                  <Image
                    src={Checkmark}
                    alt="verified buyer"
                    width={14}
                    height={14}
                    className="opacity-55"
                  />
                  Verified Buyer
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Pagination */}
        <div className="flex justify-between mt-6">
          <div className="flex gap-2 mt-4">
            {data.map((testimony, index) => (
              <button
                key={testimony.subheadline}
                className={clsx(
                  'h-2 w-2 rounded-full',
                  index === data.indexOf(currTestimony) ? 'bg-alter-black' : 'bg-alter-black-10'
                )}
                aria-label={`Go to testimony ${currTestimony.subheadline}`}
                onClick={() => setCurrTestimony(data[index])}
              />
            ))}
          </div>
          <div className="flex gap-4">
            <button
              className="pagination-arrow-container"
              onClick={prevTestimony}
              aria-label="Previous testimony"
            >
              <Image
                src={RightArrow}
                alt="Previous testimony"
                width={24}
                height={24}
                className="rotate-180 mx-auto"
              />
            </button>
            <button
              className="pagination-arrow-container"
              onClick={nextTestimony}
              aria-label="Next testimony"
            >
              <Image
                src={RightArrow}
                alt="Previous testimony"
                width={24}
                height={24}
                className="mx-auto"
              />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonies;
